// @flow

import { getShortestDeliveryTime } from './shortestDeliveryTime';
import {
  getDeliveryTime,
  getDeliveryTimeApproximately,
  getDeliveryTimeDurationSingle,
  getDeliveryTimeDurationPlural,
} from '../../componentSettings/selectors/pdbCTASettings';
import { getVbmrAvailability, getLabel } from '../../vbmr/selectors';
import type { VbmrState } from '../../vbmr/types';
import { hasVbmr, hasSinglePackage } from '.';
import type { State as RouterState } from '../../router/types';

import type { State as PdbState } from '../types';
import type { State as ComponentSettingsState } from '../../componentSettings';

type GlobalState = {
  pdb: PdbState,
  componentSettings: ComponentSettingsState,
  router: RouterState,
  vbmr: VbmrState,
};

export const getDeliveryTimeText = (
  state: GlobalState,
  pdbId: ?string = null,
): string => {
  const deliveryTime = getShortestDeliveryTime(state);

  if (!deliveryTime) {
    return '';
  }

  if (getVbmrAvailability(state) && hasVbmr(state, pdbId)) {
    return getLabel(state);
  }

  return [
    getDeliveryTime(state),
    getDeliveryTimeApproximately(state),
    deliveryTime.toString(),
    deliveryTime === 1
      ? getDeliveryTimeDurationSingle(state)
      : getDeliveryTimeDurationPlural(state),
  ].filter(string => typeof string === 'string')
    .join(' ');
};

export const showDeliveryTimeText = (
  state: GlobalState,
  pdbId: ?string = null,
): boolean => hasSinglePackage(state, pdbId)
  || (getVbmrAvailability(state) && hasVbmr(state, pdbId));

export default null;
